// Table header row, with column labels specific to each classification type.

interface ClassificationHeaderRowProps {
  classification: string;
  showLowHigh?: boolean;
  chart?: "mini";
}

/** Header text lookup for each classification + column combination. */
function headerText(classification: string, column: string): string {
  const earningMap: Record<string, string> = {
    actual: "EPS / Rev.",
    expected: "-",
    low: "-",
    high: "-",
    previous: "Prev.",
    revised: "-",
  };
  const supplyMap: Record<string, string> = {
    actual: "Results",
    expected: "-",
    low: "-",
    high: "-",
    previous: "Prev.",
    revised: "-",
  };
  const speakerMap: Record<string, string> = {
    actual: "Link",
    expected: "-",
    low: "-",
    high: "-",
    previous: "Speech",
    revised: "-",
  };
  const holidayMap: Record<string, string> = {
    actual: " ",
    expected: " ",
    low: " ",
    high: " ",
    previous: " ",
    revised: " ",
  };
  const defaultMap: Record<string, string> = {
    actual: "Act.",
    expected: "Exp.",
    low: "Low",
    high: "High",
    previous: "Prev.",
    revised: "Rev.",
  };

  switch (classification) {
    case "holiday":
      return holidayMap[column] || " ";
    case "earning":
      return earningMap[column] || "-";
    case "supply":
      return supplyMap[column] || "-";
    case "speaker":
      return speakerMap[column] || "-";
    default:
      return defaultMap[column] || "-";
  }
}

export function ClassificationHeaderRow({
  classification,
  showLowHigh,
  chart,
}: ClassificationHeaderRowProps) {
  return (
    <div className="classification-header-row calendar-grid-row">
      <div className="grid-header-cell cell-location">&nbsp;</div>
      <div className="grid-header-cell cell-time">Time</div>
      <div className="grid-header-cell cell-title">Event</div>
      <div className="grid-header-cell cell-actual">
        {headerText(classification, "actual")}
      </div>
      {chart === "mini" && <div className="grid-header-cell cell-chart">&nbsp;</div>}
      <div className="grid-header-cell cell-expected">
        {headerText(classification, "expected")}
      </div>
      {showLowHigh && (
        <>
          <div className="grid-header-cell cell-low">
            {headerText(classification, "low")}
          </div>
          <div className="grid-header-cell cell-high">
            {headerText(classification, "high")}
          </div>
        </>
      )}
      <div className="grid-header-cell cell-previous">
        {headerText(classification, "previous")}
      </div>
      <div className="grid-header-cell cell-revised">
        {headerText(classification, "revised")}
      </div>
      <div className="grid-header-cell cell-importance">&nbsp;</div>
    </div>
  );
}

export default ClassificationHeaderRow;
